import React from 'react';
import { useLanguage } from '../../../contexts/LanguageContext';

const StreakResolutionForm = ({ resolutionText, setResolutionText, resolutionYear, period, setPeriod }) => {
	const { t } = useLanguage();
	return (
		<>
			<div className='mb-4'>
				<label className='block text-sm font-medium text-gray-700 mb-1'>{t('resolutionText')}</label>
				<input
					type='text'
					value={resolutionText}
					onChange={(e) => setResolutionText(e.target.value)}
					className='w-full border border-gray-300 rounded-md shadow-sm p-2 text-sm focus:ring-blue-500 focus:border-blue-500'
					required
				/>
			</div>

			<div className='mb-4'>
				<label className='block text-sm font-medium text-gray-700 mb-1'>{t('period')}</label>
				<select
					value={period}
					onChange={(e) => setPeriod(e.target.value)}
					className='w-full border border-gray-300 rounded-md shadow-sm p-2 text-sm'
				>
					<option value='daily'>{t('daily')}</option>
					<option value='weekly'>{t('weekly')}</option>
					<option value='monthly'>{t('monthly')}</option>
				</select>
			</div>

			<div className='mb-4'>
				<label className='block text-sm font-medium text-gray-700 mb-1'>{t('year')}</label>
				<input
					type='number'
					value={resolutionYear}
					className='w-full border border-gray-300 rounded-md shadow-sm p-2 text-sm bg-gray-100'
					required
					disabled
				/>
			</div>
		</>
	);
};

export default StreakResolutionForm;
